import Device from '../Device';
import vp from '../../../services/api/vp';
import { hwh } from './Common';

const questions = hwh.concat([{
  type: 'ao-smith-pairing-code',
  name: 'aoSmithPairingCode',
  model: 'aoSmithPairingCode',
  label: 'modalAoSmithPairing.lochinvar.introduction',
  role: 'status',
  show: (values, parent) => Boolean(parent.allQuestionsValid),
  active: true,
  mfg: 'aosmith',
  subBrand: 'lochinvar',
  validation: 'required',
}]);

const addDevice = async (values, context) => null;

const lochinvar = new Device('lochinvar', { mfg: 'aosmith', questions, addDevice });

export default lochinvar;
